import { OperationReportForm31Component } from "../../../components/SupportSystem/OperationReportForm/OperationReportForm31Component"
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
export function OperationReportForm31Container () {
    const titleName = "แบบรายงานการดำเนินการพัฒนาฝีมือแรงงานของผู้ได้รับเงินช่วยเหลือหรืออุดหนุน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <OperationReportForm31Component/>
            <Footer />
        </div>   
    )
}